import { useEffect } from "react";
import type { RefObject } from "react";

/*
 * Similar to useClickOutside, except this acheives the same functionality with portals,
 * which need separate handling because they are not contained within the parent element.
 */
export const useClickOutsidePortal = (
  fieldRef: RefObject<HTMLElement | null> | null | undefined,
  poppedComponentRef: RefObject<HTMLElement | null> | null | undefined,
  setIsVisible: (visible: boolean) => void
) => {
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  });

  const isNotContainedInRef = (
    event: MouseEvent,
    ref: RefObject<HTMLElement | null> | null | undefined
  ) => {
    return (
      ref &&
      ref.current !== null &&
      ref.current !== undefined &&
      event.target !== ref.current &&
      !ref.current.contains(event.target as Node)
    );
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      isNotContainedInRef(event, fieldRef) &&
      isNotContainedInRef(event, poppedComponentRef)
    ) {
      setIsVisible(false);
    }
  };
};
